const faqData = [
  {
    question: "아산 모종 삼일파라뷰는 어디에 들어서나요?",
    answer: `
아산 모종 삼일파라뷰 센트럴은 충청남도 아산시 모종동 361-27번지 일원에 공급되는 민간임대 브랜드 아파트입니다.<br/><br/>

단지는 아산시 모종동 734번지, 모종북로 22 일원으로도 확인되며 아산 모종동 중심 생활권을 이용할 수 있는 입지입니다.<br/><br/>

롯데마트, 이마트, 아산시외버스터미널, 온양온천역 등 모종동 생활 인프라와 가까워 실거주 편의성이 높은 주거단지입니다.
`,
  },

  {
    question: "아산 모종 삼일파라뷰는 몇 세대 규모인가요?",
    answer: `
아산 모종 삼일파라뷰 센트럴은 총 352세대 규모로 조성된 민간임대 아파트입니다.<br/><br/>

단지는 지하 2층부터 지상 최고 20층, 총 4개동으로 구성되어 있습니다.<br/><br/>

대지면적은 13,923.00㎡, 연면적은 46,185.71㎡ 규모로 확인됩니다.
`,
  },

  {
    question: "아산 모종 삼일파라뷰는 어떤 타입이 있나요?",
    answer: `
아산 모종 삼일파라뷰 센트럴은 실수요 선호도가 높은 59㎡ 타입 중심으로 구성됩니다.<br/><br/>

세부 타입은 59A 234세대, 59B 118세대로 공급되어 총 352세대 모두 실속형 평면으로 구성되어 있습니다.<br/><br/>

신혼부부, 1~3인 가구, 합리적인 전세형 민간임대 아파트를 찾는 수요자에게 적합한 상품입니다.
`,
  },

  {
    question: "아산 모종 삼일파라뷰의 교통환경은 어떤가요?",
    answer: `
아산 모종 삼일파라뷰 센트럴은 온양온천역과 아산시외버스터미널 생활권을 이용할 수 있는 교통환경을 갖추고 있습니다.<br/><br/>

이순신대로, 곡교천로, 충무로 등 주요 도로망을 통해 아산과 천안 주요 생활권으로 이동하기 편리합니다.<br/><br/>

KTX 천안아산역 접근성도 기대할 수 있어 광역 이동을 고려하는 수요자에게 관심을 받을 수 있는 입지입니다.
`,
  },

  {
    question: "아산 모종 삼일파라뷰의 생활인프라는 어떤가요?",
    answer: `
아산 모종 삼일파라뷰 센트럴은 모종동 중심 생활권에 위치해 다양한 생활편의시설을 가까이 이용할 수 있습니다.<br/><br/>

롯데마트, 이마트, 롯데시네마, 아산마트, 온양온천 전통시장, 관공서와 상업시설 등이 인근에 있어 생활 편의성이 우수합니다.<br/><br/>

완성된 원스톱 생활 인프라를 누릴 수 있는 것이 아산 모종 삼일파라뷰의 주요 장점입니다.
`,
  },

  {
    question: "아산 모종 삼일파라뷰의 교육환경은 어떤가요?",
    answer: `
아산 모종 삼일파라뷰 센트럴은 모종동 생활권의 교육시설을 이용할 수 있는 입지입니다.<br/><br/>

충무초등학교, 온양중, 용화중, 온양여중, 한올중, 아산고, 온양여고 등 아산 주요 교육시설 접근성을 기대할 수 있습니다.<br/><br/>

자녀 교육과 생활 편의성을 함께 고려하는 실수요자에게 관심을 받을 수 있는 주거환경입니다.
`,
  },

  {
    question: "아산 모종 삼일파라뷰 모델하우스는 어떻게 방문하나요?",
    answer: `
아산 모종 삼일파라뷰 센트럴 모델하우스는 사전 방문예약 후 관람하는 방식을 권장합니다.<br/><br/>

방문 시 타입별 평면, 전세형 민간임대 조건, 잔여세대 현황, 계약조건, 입주 관련 상담 등을 안내받을 수 있습니다.<br/><br/>

대표 문의번호는 공개자료 기준 1522-5409로 안내되어 있습니다.
`,
  },

  {
    question: "아산 모종 삼일파라뷰는 어떤 분들에게 추천되나요?",
    answer: `
아산 모종 삼일파라뷰 센트럴은 아산 모종동 중심 생활권에서 합리적인 민간임대 아파트를 찾는 실수요자에게 추천됩니다.<br/><br/>

59㎡ 중심의 실속형 평면, 총 352세대 규모, 온양온천역·아산시외버스터미널·대형마트 생활권을 함께 고려하는 분들에게 적합합니다.<br/><br/>

삼성전자 나노시티 온양캠퍼스, 현대모터스밸리, 아산테크노밸리, 삼성디스플레이시티 등 직주근접 수요를 고려하는 분들도 관심 있게 살펴볼 만한 단지입니다.
`,
  },
];

export default faqData;